import {
  ArrayParam,
  StringParam,
  useQueryParam,
  withDefault,
} from "use-query-params";

const MAX_SELECTABLE_CHANNELS = 4;

export const useSelectedChannels = () => {
  const [selectedChannels, setSelectedChannels] = useQueryParam(
    "channels",
    withDefault(ArrayParam, []),
  );
  const [singleSelectedChannel, setSingleSelectedChannel] = useQueryParam(
    "single-channel",
    withDefault(StringParam, ""),
  );

  const clearSelectedChannels = () => setSelectedChannels([]);
  const selectChannel = (newChannel: string) => (value: boolean) =>
    setSelectedChannels((prevChannels) => {
      if (!prevChannels) {
        return [];
      }

      if (prevChannels.length >= MAX_SELECTABLE_CHANNELS && value) {
        return prevChannels;
      }

      return value
        ? [...prevChannels, newChannel]
        : prevChannels.filter((channel) => channel !== newChannel);
    });

  return {
    selectedChannels: selectedChannels as string[],
    selectChannel,
    clearSelectedChannels,
    singleSelectedChannel,
    setSingleSelectedChannel,
    isMaxSelectableChannelsReached:
      selectedChannels.length >= MAX_SELECTABLE_CHANNELS,
    MAX_SELECTABLE_CHANNELS,
  };
};
